import { QueryBuilderReadOnlyText } from './atoms';
import { TextInputProps } from '@ardoq/forms';

export const QueryBuilderText = ({ value }: TextInputProps) => {
  return <QueryBuilderReadOnlyText>{value}</QueryBuilderReadOnlyText>;
};
